import { createFileRoute } from "@tanstack/react-router";

import { AdminApifyQueueScreen } from "@/features/admin/screens/AdminApifyQueue";

export const Route = createFileRoute(
  "/_authenticated/(admin)/admin/apify-queue",
)({
  component: AdminApifyQueueScreen,
});
